module.exports = __webpack_public_path__ + "img/img06.ce596e63.jpg";